import Utils from "../../../../../../../shared/utils"

export const TITLE = `דאבל צ'ק- הערך לדיירים`

export const CONTENT = `כל מי שחיפשו דירה בשנים האחרונות יודעים שיש תחרות קשה בין הדיירים על הדירות עצמן והדירות הטובות נחטפות מהר. יוזמה מצד הדיירים למילוי ושליחת הדאבל צ'ק לבעלי הדירה הפוטנציאלית, תשדר שקיפות, הוגנות ואמינות לבעלי הדירות שהאינטרס שלהם הוא למצוא את הדייר המתאים ביותר. הדאבל צ'ק במקרה זה מהווה יתרון משמעותי על פני דיירים אחרים ואיתו תוכלו להתקדם הכי מהר עם בעל הדירה.`

export const IMAGE_URL = Utils.buildProductPageImageLink("rent/doublecheck/third-section-desk.png")